import React, { useEffect, useState, useRef, useMemo } from "react";
import { createPortal } from "react-dom";
import "../styles/UserManagmentPage.css";
import "../styles/QrCodeManagement.css";
import "../styles/SingleQRcode.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import QrIcon from "../icons/BusinessHub/QrIcon.js";
import FilterIcon from "../icons/BusinessHub/FilterIcon.js";
import ExportIcon from "../icons/BusinessHub/ExportIcon.js";
import ArrowBackIcon from "../icons/BusinessHub/ArrowBackIcon.js";
import ArrowFront from "../icons/BusinessHub/ArrowFront.js";
import { useNavigate } from "react-router-dom";
import ViewIcon from "../icons/BusinessHub/ViewIcon.js";
import SearchIcon from "../icons/BusinessHub/SearchIcon.js";
import DateRangePicker from "./DateRangePicker.js";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import DateIcon from "../icons/BusinessHub/DateIcon.js";
import CompIcon from "../icons/BusinessHub/CompIcon.js";
import companyController from "../controllers/companyController.js";
import { userService } from "../services/userService.js";
import CustomDropdown from "./StatusDropdown.js";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon.js";
import XIcon from "../icons/XIcon.js";
import QRScanner from "../components/QRScanner.js";
import QrPrintDesigner from "./QrPrintDesigner.js";
import useTableNavigationState from "../utils/useTableNavigationState.js";

const QR_TABLE_DEFAULTS = {
  fromDate: "",
  toDate: "",
  page: 1,
  qrCodeStatus: "",
  search: "",
  size: 10,
};

function QrCodeManagement() {
  const popupRef = useRef(null);
  const wrapRef = useRef(null);
  const { tableState, navigateWithTableState } = useTableNavigationState({
    defaults: QR_TABLE_DEFAULTS,
  });
  const [isTableStateInitialized, setIsTableStateInitialized] = useState(false);
  const [openQrPopup, setOpenQrPopup] = useState(false);
  const [qrImageSrc, setQrImageSrc] = useState("");
  const [qrCodeLabel, setQrCodeLabel] = useState("");
  const [qrPrintItem, setQrPrintItem] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filterpop, setfilterpop] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageInputValue, setPageInputValue] = useState("");
  const [isPageInputFocused, setIsPageInputFocused] = useState(false);
  const [statusmenu, setstusmenu] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [date, setdate] = useState("");
  const [date2, setdate2] = useState("");
  const [draftSearchValue, setDraftSearchValue] = useState("");
  const [draftSelectedStatus, setDraftSelectedStatus] = useState("");
  const [draftDate, setDraftDate] = useState("");
  const [draftDate2, setDraftDate2] = useState("");
  const [totalActive, settotalActive] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [totalEmpty, settotalEmpty] = useState("");
  const [totalPending, settotalPending] = useState("");

  const [openScanner, setOpenScanner] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState("PDF");
  const [qrPrintDesigner, setQrPrintDesigner] = useState({
    open: false,
    items: [],
    title: "",
    subtitle: "",
  });

  const selectedQrRows = data.filter((item) =>
    selected.includes(item.qrCodeId),
  );

  const getQrLabel = (qrCodeId) =>
    qrCodeId ? `QR: ${String(qrCodeId).slice(0, 4)}` : "QR: XXXX";

  const getQrPrintItem = (item) => ({
    imageSrc: String(item?.qrCodeValue || "").trim(),
    label: getQrLabel(item?.qrCodeId),
    productName: item?.productName || "",
    companyName: item?.companyName || "",
    qrCodeId: item?.qrCodeId,
  });

  const openPrintDesigner = ({ items, title, subtitle }) => {
    const printableItems = items.filter((item) => item?.imageSrc);
    if (!printableItems.length) return;

    setQrPrintDesigner({
      open: true,
      items: printableItems,
      title,
      subtitle,
    });
  };

  const closePrintDesigner = () => {
    setQrPrintDesigner({
      open: false,
      items: [],
      title: "",
      subtitle: "",
    });
    setQrPrintItem(null);
  };

  const handlescan = (value) => {
    const ProductID = value.split("/single-product/")[1]?.split(/[/?#]/)[0];

    setOpenScanner(false);

    navigate("/create-single-qr-code", {
      state: {
        ProductID,
        fromScanner: true,
      },
    });
  };
  const getPages = () => {
    const pages = [];
    if (totalPages <= 0) return pages;

    const add = (value) => {
      if (!pages.includes(value)) pages.push(value);
    };

    add(1);
    if (totalPages === 1) return pages;

    if (currentPage !== 1 && currentPage !== totalPages) {
      if (currentPage > 2) add("ellipsis");
      add(currentPage);
    }

    const extraPage =
      currentPage < totalPages ? currentPage + 1 : currentPage - 1;

    if (extraPage > 1 && extraPage < totalPages && extraPage !== currentPage) {
      add(extraPage);
    }

    if (totalPages - 1 > Math.max(currentPage, extraPage)) {
      add("ellipsis");
    }

    add(totalPages);
    return pages;
  };

  const goToTypedPage = (value = pageInputValue) => {
    const trimmedPageInput = String(value).trim();
    if (!trimmedPageInput) return false;

    const requestedPage = Number(trimmedPageInput);
    if (!Number.isInteger(requestedPage)) return false;

    const safePage = Math.min(Math.max(requestedPage, 1), totalPages || 1);
    setCurrentPage(safePage);
    setPageInputValue("");
    setIsPageInputFocused(false);
    return true;
  };

  const handleChange = (e) => {
    const value = Math.max(1, Math.min(10, Number(e.target.value)));
    setRowsPerPage(value);
    setCurrentPage(1);
    setPageInputValue("");
    setIsPageInputFocused(false);
  };

  const handleEditClick = (userId, roleName) => {
    navigate("/edit-user-details", {
      state: { userId, roleName },
    });
  };

  const handleactiondiv = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const handleOpenQrPopup = (row) => {
    const imageSrc = String(row?.qrCodeValue || "").trim();
    if (!imageSrc) return;

    setQrImageSrc(imageSrc);
    setQrCodeLabel(getQrLabel(row?.qrCodeId));
    setQrPrintItem(getQrPrintItem(row));
    setOpenQrPopup(true);
  };

  const handleCloseQrPopup = () => {
    setOpenQrPopup(false);
    setQrImageSrc("");
    setQrCodeLabel("");
    setQrPrintItem(null);
  };

  const allChecked =
    Array.isArray(data) &&
    data.length > 0 &&
    data.every((u) => selected.includes(u.qrCodeId));

  const toggleAll = (e) => {
    if (e.target.checked) {
      setSelected((prev) => [
        ...new Set([...prev, ...data.map((item) => item.qrCodeId)]),
      ]);
    } else {
      setSelected((prev) =>
        prev.filter(
          (qrCodeId) => !data.some((item) => item.qrCodeId === qrCodeId),
        ),
      );
    }
  };

  const toggleOne = (qrCodeId) => {
    setSelected((prev) =>
      prev.includes(qrCodeId)
        ? prev.filter((x) => x !== qrCodeId)
        : [...prev, qrCodeId],
    );
  };

  const toJavaTimestamp = (value) => {
    if (!value) return undefined;

    let d;

    if (value instanceof Date) {
      d = value;
    } else if (typeof value === "string" && value.includes("/")) {
      const [day, month, year] = value.split("/");

      d = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      d = new Date(value);
    }

    if (Number.isNaN(d.getTime())) return undefined;

    const pad = (n) => String(n).padStart(2, "0");

    return (
      d.getFullYear() +
      "-" +
      pad(d.getMonth() + 1) +
      "-" +
      pad(d.getDate()) +
      " " +
      pad(d.getHours()) +
      ":" +
      pad(d.getMinutes()) +
      ":" +
      pad(d.getSeconds())
    );
  };

  const fromJavaTimestamp = (value) => {
    if (!value) return "";

    const d = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return "";

    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  };

  useEffect(() => {
    if (!isTableStateInitialized) return;

    const getQrData = async () => {
      try {
        const QrData = await companyController.QrCodeRequests({
          companyId: userService.getCompID(),
          fromDate: toJavaTimestamp(date),
          toDate: toJavaTimestamp(date2),
          page: currentPage,
          qrCodeStatus: selectedStatus,
          search: searchValue,
          size: RowsPerPage,
          Authorization: userService.getUser(),
        });
        settotalPending(QrData?.data?.totalPending);
        settotalEmpty(QrData?.data?.totalEmpty);
        settotalActive(QrData?.data?.totalActive);
        setData(QrData?.data?.rows || []);
        setTotalElements(QrData?.data?.total || 0);
        setTotalPages(QrData?.data?.totalPages || 1);
      } catch (error) {
        console.error("QR API error:", error);
      }
    };
    getQrData();
  }, [
    RowsPerPage,
    currentPage,
    refreshKey,
    searchValue,
    selectedStatus,
    date,
    date2,
    isTableStateInitialized,
  ]);

  const handleRangeChange = ({ from, to }) => {
    setDraftDate(from);
    setDraftDate2(to);
  };

  const applyFilters = () => {
    setSearchValue(draftSearchValue);
    setSelectedStatus(draftSelectedStatus);
    setdate(draftDate);
    setdate2(draftDate2);
    setCurrentPage(1);
    setRefreshKey((k) => k + 1);
  };

  useEffect(() => {
    if (!statusmenu) return;

    const onOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setstusmenu(false);
      }
    };

    const onEsc = (event) => {
      if (event.key === "Escape") setstusmenu(false);
    };

    document.addEventListener("mousedown", onOutsideClick);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onOutsideClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [statusmenu]);

  useEffect(() => {
    if (!filterpop) return;

    setDraftSearchValue(searchValue);
    setDraftSelectedStatus(selectedStatus);
    setDraftDate(date);
    setDraftDate2(date2);

    const onOutsideClick = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setfilterpop(false);
      }
    };

    const onEsc = (event) => {
      if (event.key === "Escape") setfilterpop(false);
    };

    document.addEventListener("mousedown", onOutsideClick);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onOutsideClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [filterpop, searchValue, selectedStatus, date, date2]);

  const formatDate = (dateString) => {
    const d = new Date(String(dateString).replace(" ", "T"));

    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handlePrintQr = () => {
    setOpenQrPopup(false);
    openPrintDesigner({
      items: [
        qrPrintItem || {
          imageSrc: qrImageSrc,
          label: qrCodeLabel || "QR: XXXX",
        },
      ],
      title: "Customize QR Print",
      subtitle: "Add a logo and adjust this QR label before printing.",
    });
  };

  const handlePrintSelectedQrs = () => {
    openPrintDesigner({
      items: selectedQrRows.map(getQrPrintItem),
      title: "Customize Selected QR Prints",
      subtitle: "Add a logo and adjust the selected QR labels before printing.",
    });
    setIsExportModalOpen(false);
  };

  const exportActionLabel =
    exportFormat === "PDF" ? "Export as PDF" : "Print Selected";

  const currentTableState = useMemo(
    () => ({
      fromDate: toJavaTimestamp(date),
      toDate: toJavaTimestamp(date2),
      page: currentPage,
      qrCodeStatus: selectedStatus,
      search: searchValue,
      size: RowsPerPage,
    }),
    [RowsPerPage, currentPage, date, date2, searchValue, selectedStatus],
  );

  useEffect(() => {
    setCurrentPage(tableState.page || 1);
    setRowsPerPage(tableState.size || 10);
    setSearchValue(tableState.search || "");
    setSelectedStatus(tableState.qrCodeStatus || "");
    setdate(fromJavaTimestamp(tableState.fromDate));
    setdate2(fromJavaTimestamp(tableState.toDate));

    setIsTableStateInitialized(true);
  }, [tableState]);

  useEffect(() => {
    if (!isTableStateInitialized) {
      return;
    }

    navigateWithTableState("/Qr-code-management", currentTableState, {
      replace: true,
    });
  }, [currentTableState, isTableStateInitialized, navigateWithTableState]);

  const handleNavPagination = () => {
    navigateWithTableState("/create-single-qr-code", currentTableState);
  };

  return (
    <div className="business-hub-bar-screen">
      {filterpop ? (
        <div ref={wrapRef} className="filter-popup-container">
          <div className="filter-popup-container-header">Filter</div>

          <div className="filter-popup-container-body">
            <div className="filter-popup-container-body-cont">
              <div className="filter-popup-container-rows">
                <div className="filter-popup-container-rows-title">
                  <div className="filter-popup-rows-title-name">Search</div>
                  <div
                    className="filter-popup-rows-button"
                    onClick={() => setDraftSearchValue("")}
                  >
                    Clear
                  </div>
                </div>

                <div className="filter-popup-container-rows-input">
                  <div className="filter-popup-container-rows-icon">
                    <SearchIcon />
                  </div>
                  <input
                    className="filter-popup-container-rows-input-data"
                    placeholder="Search Product, Company Name..."
                    value={draftSearchValue}
                    onChange={(e) => setDraftSearchValue(e.target.value)}
                  />
                </div>
              </div>

              <div className="filter-popup-container-rows">
                <div className="filter-popup-container-rows-title">
                  <div className="filter-popup-rows-title-name">Status</div>
                  <div
                    className="filter-popup-rows-button"
                    onClick={() => {
                      setDraftSelectedStatus("");
                      setstusmenu(false);
                    }}
                  >
                    Clear
                  </div>
                </div>

                <CustomDropdown
                  rightIcon={<ArrowDownIcon />}
                  value={draftSelectedStatus}
                  onChange={setDraftSelectedStatus}
                  placeholder="Select Category"
                  options={[
                    { label: "Pending", value: "PENDING" },
                    { label: "Active", value: "ACTIVE" },
                    { label: "Empty", value: "EMPTY" },
                  ]}
                  className="filter-popup-container-rows-input-container"
                  menuClassName="status-drop-menu-container"
                  optionClassName="status-drop-menu-option"
                />
              </div>
              <div className="filter-popup-container-rows-input-date">
                <DateRangePicker
                  fromValue={draftDate}
                  toValue={draftDate2}
                  onRangeChange={handleRangeChange}
                />
              </div>
            </div>

            <div className="filter-popup-container-footer">
              <div className="filter-popup-footer-action-bottons">
                <div
                  className="filter-popup-footer-clear-bottons"
                  onClick={() => {
                    setDraftSearchValue("");
                    setDraftSelectedStatus("");
                    setDraftDate("");
                    setDraftDate2("");
                  }}
                >
                  Clear All
                </div>

                <div
                  className="filter-popup-footer-apply-bottons"
                  onClick={applyFilters}
                >
                  Apply
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {openQrPopup && (
        <div className="qr-modal-overlay">
          <div className="qr-model-create-qr-for-product">
            <div className="qr-enroll-overlays">
              <div
                className="qr-popup-close-button"
                onClick={handleCloseQrPopup}
              >
                <XIcon stroke="#424242" strokeWidth="2" />
              </div>

              <div className="qr-creation-header">
                <div className="qr-enroll-qr-box qr-enroll-qr-box-icon">
                  <SuccTickIcon />
                </div>

                <div className="create-qr-code-title-text">
                  QR Code Created Successfully
                </div>

                <div>
                  <div className="qr-enroll-qr-box qr-enroll-qr-box-image">
                    {qrImageSrc ? (
                      <img
                        className="qr-popup-image"
                        src={qrImageSrc}
                        alt="Product QR Code"
                      />
                    ) : null}
                  </div>

                  <div className="qr-popup-code-label">
                    {qrCodeLabel || "QR: XXXX"}
                  </div>
                </div>

                <div className="qr-creation-action">
                  <div
                    className="create-single-qr-action-button"
                    onClick={handlePrintQr}
                  >
                    Print
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <QrPrintDesigner
        open={qrPrintDesigner.open}
        qrItems={qrPrintDesigner.items}
        title={qrPrintDesigner.title}
        subtitle={qrPrintDesigner.subtitle}
        onClose={closePrintDesigner}
        onPrinted={closePrintDesigner}
      />

      {isExportModalOpen &&
        createPortal(
          <div
            className="productSubmission-export-overlay"
            onClick={() => setIsExportModalOpen(false)}
          >
            <div
              className="productSubmission-export-modal qr-export-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="productSubmission-export-close"
                onClick={() => setIsExportModalOpen(false)}
                aria-label="Close export modal"
              >
                <XIcon stroke="#424242" strokeWidth="2" />
              </button>

              <div className="productSubmission-export-title">
                Export & Print
              </div>
              <div className="productSubmission-export-subtitle">
                Print the QR codes for the selected table rows
              </div>

              <div className="productSubmission-export-format-grid qr-export-format-grid">
                {[
                  {
                    key: "PDF",
                    title: "PDF File",
                    subtitle: "Open printable layout for saving as PDF",
                  },
                  {
                    key: "PRINT",
                    title: "Print",
                    subtitle: "Send the selected QR labels to printer",
                  },
                ].map((option) => (
                  <button
                    key={option.key}
                    type="button"
                    className={`productSubmission-export-format-card ${exportFormat === option.key ? "is-active" : ""}`}
                    onClick={() => setExportFormat(option.key)}
                  >
                    <div className="productSubmission-export-format-title">
                      {option.title}
                    </div>
                    <div className="productSubmission-export-format-subtitle">
                      {option.subtitle}
                    </div>
                  </button>
                ))}
              </div>

              <div className="productSubmission-export-summary qr-export-summary">
                <div className="productSubmission-export-summary-title">
                  Export Summary
                </div>
                <ul>
                  <li>
                    Format: {exportFormat === "PDF" ? "PDF File" : "Print"}
                  </li>
                  <li>Scope: Selected Rows</li>
                  <li>Selected QR Codes: {selectedQrRows.length}</li>
                  <li>Output: QR image and corresponding label only</li>
                </ul>
              </div>

              <div className="qr-export-preview-grid">
                {selectedQrRows.length ? (
                  selectedQrRows.map((item) => (
                    <div
                      className="qr-export-preview-card"
                      key={item.qrCodeId || item.productID}
                    >
                      <div className="qr-export-preview-frame">
                        {item?.qrCodeValue ? (
                          <img
                            className="qr-export-preview-image"
                            src={item.qrCodeValue}
                            alt={getQrLabel(item.qrCodeId)}
                          />
                        ) : (
                          <div className="qr-export-preview-empty">
                            QR unavailable
                          </div>
                        )}
                      </div>
                      <div className="qr-export-preview-label">
                        {getQrLabel(item.qrCodeId)}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="qr-export-empty-state">
                    Select one or more rows from the table before exporting.
                  </div>
                )}
              </div>

              <div className="productSubmission-export-footer">
                <div
                  className={`qr-export-action-button ${
                    !selectedQrRows.length ? "is-disabled" : ""
                  }`}
                  onClick={() => {
                    if (!selectedQrRows.length) return;
                    handlePrintSelectedQrs();
                    setIsExportModalOpen(false);
                  }}
                >
                  {exportActionLabel}
                </div>
                <div
                  className="qr-export-cancel-button"
                  onClick={() => setIsExportModalOpen(false)}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}

      <div className="business-hub-bar-header-container">
        <BusinessHubHeader />
      </div>

      <div className="business-hub-page-design-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active="D" />
        </div>

        <div className="business-hub-container">
          <div className="content-container-qr-mange">
            <div className="product-managemnet-qr-code-container">
              <div className="product-managemnet-qr-code-container-header">
                <div className="product-managemnet-qr-code-container-header-intro">
                  <div className="product-managemnet-qr-header-icons">
                    <QrIcon size="40" />
                  </div>

                  <div className="product-managemnet-qr-code-header-text">
                    <div className="product-managemnet-qr-code-header-title">
                      QR Code Management
                    </div>

                    <div className="product-managemnet-qr-code-header-disc">
                      Generate, export, print, and track QR codes.
                    </div>
                  </div>
                </div>

                <div className="product-managemnet-qr-code-action-buttoms">
                  <div
                    className="product-managemnet-qr-code-single-qr"
                    onClick={() => setOpenScanner(true)}
                  >
                    Scan QR-code
                  </div>

                  {openScanner && (
                    <QRScanner
                      onScanSuccess={handlescan}
                      onClose={() => setOpenScanner(false)}
                    />
                  )}

                  <div
                    className="product-managemnet-qr-code-bulk-qr"
                    onClick={() => navigate("/create-bulk-qr-code")}
                  >
                    Generate Bulk QRs
                  </div>

                  <div
                    className="product-managemnet-qr-code-single-qr"
                    onClick={() => handleNavPagination()}
                  >
                    Create Single QR
                  </div>
                </div>
              </div>

              <div className="product-managemnet-qr-code-container-body">
                <div className="product-managemnet-qr-body-header">
                  <div className="product-managemnet-qr-body-data-disc">
                    <div className="product-managemnet-qr-body-total">
                      <div className="number">{totalElements}</div>
                      total QR codes
                    </div>

                    <div className="product-managemnet-qr-body-active">
                      <div className="number1">{totalActive}</div>
                      Active
                    </div>

                    <div className="product-managemnet-qr-body-pending">
                      <div className="number2">{totalPending}</div>
                      Pending
                    </div>

                    {/* <div className="product-managemnet-qr-body-empty">
                      <div className="number3">{totalEmpty}</div>
                      Empty
                    </div> */}
                  </div>

                  <div className="product-managemnet-qr-body-action-buttons">
                    <div
                      className="product-managemnet-qr-body-action-filter"
                      onClick={() => setfilterpop(true)}
                    >
                      <FilterIcon />
                      Filter
                    </div>

                    <div
                      className="product-managemnet-qr-body-action-export"
                      onClick={() => {
                        setExportFormat("PDF");
                        setIsExportModalOpen(true);
                      }}
                    >
                      <ExportIcon />
                      Export/Print
                    </div>
                  </div>
                </div>

                <div className="product-managemnet-qr-body-table">
                  <div className="user-info-display-table">
                    <div className="user-info-table">
                      <div className="table-header-row">
                        <div className="cell-content-user-qr">
                          <div className="cell-content-header-name-data-qr">
                            <div className="user-checkbox-cell">
                              <input
                                style={{ cursor: "pointer" }}
                                type="checkbox"
                                checked={allChecked}
                                onChange={toggleAll}
                              />
                            </div>
                            QR Code
                          </div>
                        </div>

                        <div className="cell-content-qr">Product</div>
                        <div className="cell-content-data-phone">
                          Company Name
                        </div>
                        <div className="cell-content-qr-state">Status</div>
                        <div className="cell-content-data-roll">
                          Date Created
                        </div>
                        <div className="cell-content">Actions</div>
                      </div>

                      {data?.map((item, index) => (
                        <div
                          className="user-table-row qr-mobile-card-row"
                          key={index}
                        >
                          <div className="cell-content-user-name qr-mobile-card-code">
                            <div className="cell-content-user-name-data">
                              <div className="user-checkbox-cell">
                                <input
                                  type="checkbox"
                                  style={{ cursor: "pointer" }}
                                  checked={selected.includes(item.qrCodeId)}
                                  onChange={() => {
                                    toggleOne(item.qrCodeId);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="emp-prof-name qr-mobile-card-code-wrap">
                              <div className="user-table-qr-name qr-mobile-card-code-text">
                                {item.productID || "-"}
                              </div>
                            </div>
                          </div>

                          <div className="cell-content-qr qr-mobile-card-product">
                            {item.productName}
                          </div>

                          <div className="cell-content-data-phone qr-mobile-card-company">
                            <span className="qr-mobile-card-meta-icon">
                              <CompIcon />
                            </span>
                            <span>{item.companyName}</span>
                          </div>

                          <div className="cell-content-qr-state qr-mobile-card-status">
                            <div
                              className={`qr-cell-status ${
                                !item.qrCodeStatus
                                  ? "qr-status-empty"
                                  : item.qrCodeStatus.toLowerCase() === "active"
                                    ? "qr-status-active"
                                    : item.qrCodeStatus.toLowerCase() ===
                                        "pending"
                                      ? "qr-status-pending"
                                      : "qr-status-empty"
                              }`}
                            >
                              {item.qrCodeStatus}
                            </div>
                          </div>

                          <div className="cell-content-data-roll qr-mobile-card-date">
                            <span className="qr-mobile-card-meta-icon">
                              <DateIcon strokeWidth="1.2" />
                            </span>
                            <span>{formatDate(item.createdDate)}</span>
                          </div>

                          <div className="cell-content-view-qr qr-mobile-card-view">
                            <div
                              className="more-actions-icon qr-mobile-card-view-button"
                              onClick={() => handleOpenQrPopup(item)}
                            >
                              <ViewIcon />
                              View
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="nav-bar-section">
                    {/* <div className="nav-bar-functionality">
                      <div className="functionality-description">
                        Rows per page
                      </div>
                      <div className="number-of-rows-displayed">
                        <div className="number-of-rows-displayed-container">
                          <input
                            className="number-displayed"
                            type="number"
                            value={RowsPerPage}
                            onChange={handleChange}
                            min={1}
                            max={10}
                          />
                        </div>
                      </div>
                      <div className="over-all-rows">
                        of {totalElements} rows
                      </div>
                    </div> */}

                    <div className="nav-table-bar">
                      <form
                        className="qr-page-input-form"
                        onSubmit={(e) => {
                          e.preventDefault();
                          goToTypedPage();
                        }}
                      >
                        <input
                          type="number"
                          min="1"
                          max={totalPages}
                          className="qr-page-input"
                          value={
                            isPageInputFocused
                              ? pageInputValue
                              : String(currentPage)
                          }
                          onFocus={(e) => {
                            setIsPageInputFocused(true);
                            setPageInputValue(String(currentPage));
                            e.target.select();
                          }}
                          onChange={(e) => setPageInputValue(e.target.value)}
                          onBlur={() => {
                            if (!goToTypedPage()) {
                              setPageInputValue("");
                              setIsPageInputFocused(false);
                            }
                          }}
                          aria-label="Go to page"
                        />
                      </form>

                      <div
                        className={`nav-bar-button ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (currentPage > 1) {
                            setCurrentPage((p) => p - 1);
                            setPageInputValue("");
                            setIsPageInputFocused(false);
                          }
                        }}
                      >
                        <ArrowBackIcon />
                      </div>

                      <div className="nav-bar-buttons">
                        {getPages().map((item, i) =>
                          item === "ellipsis" ? (
                            <div className="three-dots-nav" key={`e-${i}`}>
                              ...
                            </div>
                          ) : (
                            <div
                              key={item}
                              className={`nav-page-number ${
                                currentPage === item ? "active-page" : ""
                              }`}
                              onClick={() => {
                                setCurrentPage(item);
                                setPageInputValue("");
                                setIsPageInputFocused(false);
                              }}
                            >
                              {item}
                            </div>
                          ),
                        )}
                      </div>

                      <div
                        className={`nav-bar-button ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (currentPage < totalPages) {
                            setCurrentPage((p) => p + 1);
                            setPageInputValue("");
                            setIsPageInputFocused(false);
                          }
                        }}
                      >
                        <ArrowFront />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrCodeManagement;
